export const GET_EXAM_SCHEDULE_SETTING = 'GET_EXAM_SCHEDULE_SETTING'
export const SAVE_EXAM_SCHEDULE_SETTING = 'SAVE_EXAM_SCHEDULE_SETTING'
export const DELETE_EXAM_SCHEDULE_SETTING = 'DELETE_EXAM_SCHEDULE_SETTING'
export const DELETE_MANY_EXAM_SCHEDULE_SETTINGS = 'DELETE_MANY_EXAM_SCHEDULE_SETTINGS'
export const GENERATE_INDIVIDUAL_SCHEDULE = 'GENERATE_INDIVIDUAL_SCHEDULE'
export const GENERATE_CLASS_SCHEDULE = 'GENERATE_CLASS_SCHEDULE'
